import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageItem } from '@core/enums/local-storage-item';
import { CaiServerError } from '@core/models/cai-server-error';
import { CassError } from '@core/models/cass-error';
import { environment } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Logger } from './logger.service';

@Injectable({
	providedIn: 'root'
})
export class CassHttpInterceptorService implements HttpInterceptor {

	private appSessionId: string;

	constructor (
		private _route: Router,
		private _logger: Logger) {
		this.appSessionId = (Math.random() + 1).toString(36).substring(2);
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		let modifiedReq = req.clone({
			headers: req.headers
				.set("X-CASS-App-Session", this.appSessionId)
				.set("X-Requested-With", "XMLHttpRequest")
		});

		const jwt = sessionStorage.getItem(LocalStorageItem.JWT);
		if (jwt) {
			modifiedReq = modifiedReq.clone({
				headers: modifiedReq.headers.set("JWT", jwt)
			});
		}

		return next.handle(modifiedReq).pipe(
			catchError((error) => {
				this.logError(error);
				if (error.status === 401) {
					this._route.navigate(['login']);
				}

				return throwError(() => this.convertToCassError(error))
			})
		)
	}

	private logError(error: any): void {
		if (!environment.production) {
			this._logger.error("HTTP", `Caught Http error: ${JSON.stringify(error)}`);
		}
	}

	private convertToCassError(response: HttpErrorResponse): CassError | undefined {
		//if (response && response.status === 401) {
		//	console.log("http: not looged in");
		//}

		const caiServerError = response.error as CaiServerError;
		if (caiServerError && caiServerError.messageKey && caiServerError.messageKey.startsWith("SelfService.SubscriberDiscount.")) {
			switch (caiServerError.messageKey) {
				case "SelfService.SubscriberDiscount.ValidationError":
				case "SelfService.SubscriberDiscount.UnexpectedError":
					{
						const cassError = CassError.createErrorWithMessageKey(caiServerError.messageKey, { serverErrorMessage: caiServerError.message });
						cassError.isDiscountApplicationError = true;
						return cassError;
					}
					break;
				default:
					{
						// discount application error
						const cassError = CassError.createErrorWithMessageKey(caiServerError.messageKey);
						cassError.isDiscountApplicationError = true;
						return cassError;
					}
					break;
			}
		}
		// this is going to be obsolete and will be removed once BE sends errorCode instead of code
		else if (response.status === 401 && response.error.code === 1) {
			return CassError.createErrorWithCode(response.status, response.error.code, response.error.message || "");
		}
		else if (response.status === 401 && response.error.errorCode === 1) {
			return CassError.createErrorWithCode(response.status, response.error.errorCode, response.error.message || "");
			//return CassError.createErrorWithMessageKey("ERRORS.LOGIN_FAILED");
		}
		else if (Math.floor(response.status / 100) === 4 && (caiServerError.message || caiServerError.messageKey)) {
			if (caiServerError.message) {
				const cassError = CassError.createErrorWithText(caiServerError.message);
				cassError.isUnexpected = false;
				return cassError;
			}
			else {
				const cassError = CassError.createErrorWithMessageKey(`SelfService.${caiServerError.messageKey}`, { code: response.error.message });
				cassError.isUnexpected = false;
				return cassError;
			}
		}
		else if (response.error.message) {
			// obsolete BE error format
			const cassError = CassError.createErrorWithMessageKey("ERRORS.UNEXPECTED_API_ERROR", { code: response.error.message });
			cassError.isUnexpected = true;
			return cassError;
		}
		else {
			// Unexpected server error - show generic message to the user
			const cassError = CassError.createErrorWithMessageKey(caiServerError && caiServerError.messageKey ? caiServerError.messageKey : "ERRORS.UNEXPECTED_API_ERROR", { code: caiServerError?.code || response.status });
			cassError.isUnexpected = true;
			return cassError;
		}
	}
}
